import { useState } from "react";
import {
  Button,
  Checkbox,
  CheckboxGroup,
  ModalBody,
  ModalFooter,
  Stack,
  Text
} from "@chakra-ui/react";
import FileList from "./FileList";
import { Scene } from "../../../../types/uploads";
import { useModels } from "../../../../context";
import { Model } from "../../../../types/scenes";

type Props = {
  models?: Model[];
  onSelect: (value: Model[]) => void;
  onNext: () => void;
  onCancel: () => void;
  files?: Scene[];
  ingestError?: string;
}

function SelectModel({ models = [], onSelect, files, onCancel, onNext, ingestError }: Props) {
  const [ error, setError ] = useState<string>();
  const { models: modelConfig } = useModels();
  const value = models.map(({ id }) => id);

  const handleSelect = (selectedValues: string[]) => {
    const selectedModels = selectedValues.map((id) => parseInt(id));

    onSelect(modelConfig.filter(({ id }) => selectedModels.includes(id)));
  };

  const handleNext = () => {
    if (models.length === 0) {
      setError("Select at least one model.");
    } else {
      onNext();
    }
  };

  return (
    <>
      <ModalBody>
        <Text as="h3" fontSize="md" flex="1">Select Model</Text>
        <CheckboxGroup value={value.map(String)} onChange={handleSelect}>
          <Stack spacing="4" direction="row" my="4">
            { modelConfig.map(({ id, name, version }) => (
              <Checkbox key={id} value={id.toString()}>{name} ({ version })</Checkbox>
            ))}
          </Stack>
        </CheckboxGroup>
        {(error || ingestError) && <Text mt="4" bg="red.200" color="base.500" fontSize="small" padding={2} borderRadius={4}><strong>Error:</strong> {error || ingestError}</Text>}
        <FileList files={files} />
      </ModalBody>
      <ModalFooter display="flex" gap="5">
        <Button variant="ghost" onClick={onCancel}>Cancel</Button>
        <Button onClick={handleNext}>Next: Confirm</Button>
      </ModalFooter>
    </>
  );
}

export default SelectModel;
